import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { isEmpty } from 'lodash'
import Fuse from 'fuse.js'

import Layout from 'containers/Layout'
import HardwareIndex from 'containers/HardwareIndex'
import useDataRefresh from 'hooks/useDataRefresh'
import paginationCoordinator from 'utils/paginationCoordinator'

import { fetchDevices } from 'store/Devices/actions'
import { getDevicesWithConfigurations } from 'store/Devices/selector'
import { getCurrentVenueId } from 'store/Venues/selector'
import { getDevicesFilter } from 'store/AppState/selector'
import { fetchConfigurations } from 'store/Configurations/actions'

const FUSE_OPTIONS = {
  threshold: 0.2,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: ['name', 'deviceId', 'appTypes'],
}

export const DevicesIndex = (props) => {
  const history = useHistory()

  const { fetchDevices, fetchConfigurations, devices, currentVenueId, searchQuery } = props

  const fetchData = () => {
    if (isEmpty(currentVenueId)) {
      return Promise.resolve()
    } else {
      return Promise.all([fetchDevices(currentVenueId), fetchConfigurations(currentVenueId)])
    }
  }

  const [isLoadingDevices] = useDataRefresh(fetchData, [currentVenueId])
  const renderedDevices = isEmpty(searchQuery)
    ? devices
    : new Fuse(devices, FUSE_OPTIONS).search(searchQuery)

  const renderDevicesByState = () => {
    const { devicesFilter } = props
    if (devicesFilter === 'pending') {
      return renderedDevices.filter((renderedDevice) => !isEmpty(renderedDevice.lockedAt))
    } else if (devicesFilter === 'registered') {
      return renderedDevices.filter((renderedDevice) => isEmpty(renderedDevice.lockedAt))
    }
  }

  const allPendingDevicesNumber = devices.filter((device) => !isEmpty(device.lockedAt)).length

  const displayAllPendingDevicesNumber =
    allPendingDevicesNumber === 0 ? 'Pending' : `Pending (${allPendingDevicesNumber})`

  const paginator = paginationCoordinator(renderDevicesByState(), history)

  return (
    <Layout
      isSidebar={true}
      pendingDevicesNumber={displayAllPendingDevicesNumber}
      title="Registered Hardware"
    >
      <HardwareIndex
        isFilteringItems={!isEmpty(searchQuery)}
        isLoadingDevices={isLoadingDevices}
        paginator={paginator}
      />
    </Layout>
  )
}

DevicesIndex.propTypes = {
  fetchDevices: PropTypes.func.isRequired,
  fetchConfigurations: PropTypes.func.isRequired,
  devices: PropTypes.array.isRequired,
  currentVenueId: PropTypes.string,
  searchQuery: PropTypes.string.isRequired,
  devicesFilter: PropTypes.string,
}

const mapStateToProps = (state) => ({
  devices: getDevicesWithConfigurations(state),
  currentVenueId: getCurrentVenueId(state),
  searchQuery: getDevicesFilter(state, 'searchQuery'),
  devicesFilter: getDevicesFilter(state, 'status'),
})

const mapDispatchToProps = {
  fetchDevices,
  fetchConfigurations,
}

export default connect(mapStateToProps, mapDispatchToProps)(DevicesIndex)
